import { Directive, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { FishDropdownConfig } from './dropdown-config';

/**
 * Transforms a node into a dropdown.
 */

export class FishDropdown {
  private _toggleElement: any;

  /**
   * Indicates that the dropdown should open upwards
   */
   up: boolean;

  /**
   * Indicates that dropdown should be closed when selecting one of dropdown items (click) or pressing ESC.
   */
   autoClose: boolean;

  /**
   *  Defines whether or not the dropdown-menu is open initially.
   */
   _open = false;

  /**
   *  An event fired when the dropdown is opened or closed.
   *  Event's payload equals whether dropdown is open.
   */
   openChange = new EventEmitter();

  constructor(config: FishDropdownConfig) {
    this.up = config.up;
    this.autoClose = config.autoClose;
  }


  /**
   * Checks if the dropdown menu is open or not.
   */
  isOpen(): boolean { return this._open; }

  /**
   * Opens the dropdown menu of a given navbar or tabbed navigation.
   */
  open(): void {
    if (!this._open) {
      this._open = true;
      this.openChange.emit(true);
    }
  }

  /**
   * Closes the dropdown menu of a given navbar or tabbed navigation.
   */
  close(): void {
    if (this._open) {
      this._open = false;
      this.openChange.emit(false);
    }
  }

  /**
   * Toggles the dropdown menu of a given navbar or tabbed navigation.
   */
  toggle(): void {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  closeFromOutsideClick($event) {
    if (this.autoClose && $event.button !== 2 && !this._isEventFromToggle($event)) {
      this.close();
    }
  }

  closeFromOutsideEsc() {
    if (this.autoClose) {
      this.close();
    }
  }

  /**
   * @internal
   */
  set toggleElement(toggleElement: any) { this._toggleElement = toggleElement; }

  private _isEventFromToggle($event) { return !!this._toggleElement && this._toggleElement.contains($event.target); }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[fishDropdown]',
  exportAs: 'fishDropdown',
  host: {
    '[class.dropdown]': '!up',
    '[class.dropup]': 'up',
    '[class.show]': 'isOpen()',
    '(keyup.esc)': 'closeFromOutsideEsc()',
    '(document:click)': 'closeFromOutsideClick($event)'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FishDropdownConfig, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'up': [{ type: Input },],
'autoClose': [{ type: Input },],
'_open': [{ type: Input, args: ['open', ] },],
'openChange': [{ type: Output },],
};
}

/**
 * Allows the dropdown to be toggled via click. This directive is optional.
 */

export class FishDropdownToggle {
  constructor(public dropdown: FishDropdown, elementRef: ElementRef) {
    dropdown.toggleElement = elementRef.nativeElement;
  }

  toggleOpen() { this.dropdown.toggle(); }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[fishDropdownToggle]',
  host: {
    'class': 'dropdown-toggle',
    'aria-haspopup': 'true',
    '[attr.aria-expanded]': 'dropdown.isOpen()',
    '(click)': 'toggleOpen()'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FishDropdown, },
{type: ElementRef, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
